import React, { useState, useEffect } from "react"
import classNames from "classnames"
import CommunitySearchForm from "../../../../forms/CommunitySearchForm"
import { setSearchQuery } from "../../useSearch/actionCreators"
import styles from "./index.module.scss"

const SearchFormWrapper = ({ state, dispatch }) => {
  const [query, setQuery] = useState(state.searchParamGroup.query)
  useEffect(() => {
    setQuery(state.requestResultGroup.query)
  }, [state.requestResultGroup])
  return (
    <div
      className={classNames(styles.searchFormContainer, {
        [styles.emptyInput]: !state.searchParamGroup.query,
        [styles.fullInput]: !!state.searchParamGroup.query,
      })}
    >
      <CommunitySearchForm
        emptyMode={!state.searchParamGroup.query}
        placeholder="Search for community"
        searchQuery={query}
        onChange={(query) =>
          setQuery(query.length > 200 ? query.substring(0, 200) : query)
        }
        onSearch={() => dispatch(setSearchQuery(query.trim()))}
      />
    </div>
  )
}
export default SearchFormWrapper
